import React from "react";
import Navb from "../../../../components/navbar/Navb";
import Footer from "../../../../components/footer/Footer";
import RecipiePage from "../../../../components/recipiePage/RecipiePage";
import Recpiesimg1 from "./recpiesimg1.png";
import Recpiesimg2 from "./recpiesimg2.png";
import Recpiesimg3 from "../../img3.png";
import Recpiesimg4 from "../../img10.png";
import Recpiesimg5 from "../../img7.png";
import Img1 from "./img1.png";
import Timer from "../timer.png";
import "../recipe.css";
const Besanburfi = () => {
  return (
    <>
      <RecipiePage
        Recpiesimg1={Recpiesimg1}
        Recpiesimg2={Recpiesimg2}

        Recpiesimg3={Recpiesimg3}
        Recpiesimg4={Recpiesimg4}
        Recpiesimg5={Recpiesimg5}
        Img1={Img1}
        Name="Besan Burfi"
        Ul1={
          <ul>
            <li>
              <span className="Bold">Nandi besan (chickpea flour)</span>
            </li>
            <li>Ghee</li>
            <li>Sugar</li>
            <li>Water</li>
            <li>Cardamom powder</li>
          </ul>
        }
        Ul2={
          <ul className="noDecoration">
            <li>2 cups</li>
            <li>1/2 cups</li>
            <li>1 cups</li>
            <li>1/2 cups</li>
            <li> 1 tablespoon</li>
          </ul>
        }
        Ul3={
          <ul>
            <li>Chopped nuts</li>
          </ul>
        }
        Ul4={
          <ul className="noDecoration">
            <li>garnish</li>
          </ul>
        }
        Ol1={
          <ol>
            <li>
              In a pan, heat ghee and add besan. Roast on low heat until it
              turns golden brown and releases a nutty aroma
            </li>
            <li>
              In a separate pan, combine sugar and water to make a syrup. Heat
              until it reaches a one-string consistency.
            </li>
            <li>
              Slowly add the besan to the sugar syrup, stirring continuously to
              avoid lumps.
            </li>
            <li>
              Continue cooking on low heat until the mixture thickens and starts
              leaving the sides of the pan.
            </li>
            <li>Add cardamom powder and mix well.</li>
            <li>
              Transfer the mixture to a greased tray and spread it evenly.
            </li>
            <li>
              Garnish with chopped nuts and press them lightly into the mixture.
            </li>
            <li>
              Allow it to cool, then cut into square or diamond-shaped pieces.
            </li>
            <li>Enjoy the delicious Besan Burfi!</li>
          </ol>
        }
        Item1="Whole Atta Cookies"
        Item2="Dalia Salad"
        Item3="Besan burfi"
        Link1="wholeattacookies"
        Link2="daliasalad"
        Link3="besanburfi"
      />
      {/* <Navb />
      <div className="singleRecipeTop">Besan Burfi</div>
      <img className="singleRecipeTopimg" src={Recpiesimg1} alt="Recpiesimg1" />
      <div className="singleRecipeBot">
        
        <div className="singleRecipeBotLeftItems">
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <hr />
          <div className="singleRecipeBotLeftItem">
            
            <ol>
              <li>
                1 cup{" "}
                <span className="Bold">Nandi besan (chickpea flour)</span>{" "}
              </li>
              <li>1/2 cup ghee</li>
              <li>1 cup sugar</li>
              <li>1/4 cup water</li>
              <li>1/2 teaspoon cardamom powder</li>
              <li>Chopped nuts for garnish (almonds, pistachios)</li>
            </ol>
          </div>
         
          <hr />
          <div className="flexitemrecipe">
            <img src={Recpiesimg2} alt="Recpiesimg2" />
            Nandi Besan
          </div>
        </div>
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          <ol>
            <li>
              In a pan, heat ghee and add besan. Roast on low heat until it
              turns golden brown and releases a nutty aroma
            </li>
            <li>
              In a separate pan, combine sugar and water to make a syrup. Heat
              until it reaches a one-string consistency.
            </li>
            <li>
              Slowly add the besan to the sugar syrup, stirring continuously to
              avoid lumps.
            </li>
            <li>
              Continue cooking on low heat until the mixture thickens and starts
              leaving the sides of the pan.
            </li>
            <li>Add cardamom powder and mix well.</li>
            <li>
              Transfer the mixture to a greased tray and spread it evenly.
            </li>
            <li>
              Garnish with chopped nuts and press them lightly into the mixture.
            </li>
            <li>
              Allow it to cool, then cut into square or diamond-shaped pieces.
            </li>
            <li>Enjoy the delicious Besan Burfi!</li>
          </ol>
        </div>
      </div>
      <div className="singleRecipeEnd">
        <div className="singleRecipeEndTitle">You Might Also Like</div>
        <div className="singleRecipeEndItems">
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
            <a href="/recipes/besankadhirice">
              <img src={Recpiesimg3} alt="Recpiesimg3" />
              <div className="singleRecipeEndItemTitle">
              Besan Kadhi & Rice
              </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 30 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
            <a href="/recipes/nandimeatmasalacurry">
              <img src={Recpiesimg4} alt="Recpiesimg4" />
              <div className="singleRecipeEndItemTitle">Nandi Meat Masala Curry</div>
            </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 50 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
            <a href="/recipes/daliakhichadi">
              <img src={Recpiesimg5} alt="Recpiesimg5" />
              <div className="singleRecipeEndItemTitle">
              Dalia Khichadi
              </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 20 mins</span>
            </div>
          </div>
        </div>
      </div>
      <Footer /> */}
    </>
  );
};

export default Besanburfi;
